import React from "react";
import { Box, Typography, TextField } from "@mui/material";
import RequiredLabel from "./RequiredLabel";

/**
 * 数値入力フィールドコンポーネント
 *
 * @param {string}   label        表示ラベル
 * @param {string}   name         フィールド名（フォーム連携用）
 * @param {number|string} value   入力中の値
 * @param {object|boolean} [error=false] React Hook Form の error オブジェクト または false
 * @param {function} onChange     値変更ハンドラ (name: string, value: number|string) => void
 * @param {boolean}  [required=true] 必須表示フラグ
 * @param {string}   [placeholder="5"] プレースホルダー
 * @param {number}   [min=1]      最小値（inputProps.min）
 * @param {number}   [maxLength]      桁数（maxLength）
 */

const NumberInputField = ({
  label,
  name,
  value,
  error,
  onChange,
  required = true,
  placeholder = "5",
  min = 1,
  maxLength,
}) => {
  return (
    <Box sx={{ display: "flex", flexDirection: "column", width: "100%" }}>
      <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1 }}>
        <Typography>{label}</Typography>
        <RequiredLabel show={required} />
      </Box>
      <TextField
        required={required}
        fullWidth
        id={name}
        name={name}
        type="number"
        value={value || ""}
        onChange={(e) => {
          const val = e.target.value;
          if (!maxLength || val.length <= maxLength) {
            onChange(name, val);
          }
        }}
        placeholder={placeholder}
        variant="outlined"
        inputProps={{ min }}
        error={!!error}
        helperText={error?.message}
      />
    </Box>
  );
};

export default NumberInputField;
